import { getWindowDimensions } from '../../../hooks/useWindowDimensions';
// import { DeviceFormFactor, useDeviceForm } from '../../../hooks/useDeviceForm';
export var ScreenSize;
(function (ScreenSize) {
    ScreenSize[ScreenSize["Small"] = 0] = "Small";
    ScreenSize[ScreenSize["Large"] = 1] = "Large";
})(ScreenSize || (ScreenSize = {}));
export function useScreenSize() {
    // NOTE: These are not compatible as they stand, the breakpoints must be changed before this hook can be used
    // const deviceForm = useDeviceForm();
    // if (
    //   deviceForm === DeviceFormFactor.Mobile ||
    //   deviceForm === DeviceFormFactor.Tablet
    // ) {
    //   return ScreenSize.Small;
    // } else {
    //   return ScreenSize.Large;
    // }
    // TODO: Remove fix when breakpoints are compatible
    var width = getWindowDimensions().width;
    if (width < 1024) {
        return ScreenSize.Small;
    }
    else {
        return ScreenSize.Large;
    }
}
